import React from "react";
import "../index.css";

const WorshipWithUs = () => {
    return (
        <section className="bg-white w-full py-16 px-4 md:px-12 lg:px-20">
            <div className="max-w-6xl mx-auto">

                {/* Main Card */}
                <div className="relative rounded-2xl overflow-hidden min-h-[480px] flex items-center justify-center">

                    {/* Background Image */}
                    <img
                        src="/worship.jpg"
                        alt="Worship background"
                        className="absolute inset-0 w-full h-full object-cover object-center"
                    />

                    {/* 40% Dark Overlay */}
                    <div className="absolute inset-0 bg-black/40" />

                    {/* Center Content */}
                    <div className="relative z-10 flex flex-col items-center text-center px-6 md:px-20 py-16 gap-5">

                        {/* Eyebrow */}
                        <div className="flex items-center gap-2">
                            <span className="block w-7 h-px bg-red-400" />
                            <span className="text-red-400 text-xs font-semibold tracking-widest uppercase">
                                Come As You Are
                            </span>
                            <span className="block w-7 h-px bg-red-400" />
                        </div>

                        {/* Heading */}
                        <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight max-w-2xl">
                            Worship With Us
                        </h1>

                        {/* Description */}
                        <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-xl">
                            Visit any of our nearest Bethels and experience the supernatural
                            teaching of the Holy Spirit
                        </p>

                        {/* CTA Button */}
                        <button className="mt-2 flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white text-sm font-semibold px-8 py-3 rounded-sm transition-all duration-200">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            Find Bethel
                        </button>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default WorshipWithUs;